import Enumerable from "linq";
export class InformationListViewModel {
    constructor(data = null) {
        if (!data) {
            return;
        }
        this.model = data;
        this.response = Enumerable.from(data.records).select(x => new InformationViewModel(x)).toArray();
    }
    model = null;
    response = [];
}
export class InformationViewModel {
    constructor(model) {
        this.model = model;
    }
    model;
    get informationNo() {
        return this.model.informationNo;
    }
    get weight() {
        return this.model.weight;
    }
    get startAt() {
        return this.model.startAt;
    }
    get isAnswered() {
        return this.model.isAnswered;
    }
    get isResponseRequired() {
        return this.model.isResponseRequired;
    }
    get subject() {
        return this.model.subject;
    }
    get responseDeadline() {
        return this.model.responseDeadline;
    }
    get isReaded() {
        return this.model.isReaded;
    }
}
